module.exports = __webpack_public_path__ + "static/media/close.4598e729.svg";